import { AgencyResponseItem } from '@/types/service-response'

export class Agency {
  public constructor (
    readonly id: number,
    readonly code: string,
    readonly name: string,
    readonly path: string
  ) {}

  static createFromResponse (responseData: AgencyResponseItem[]): Array<Agency> {
    let result: Array<Agency> = []
    if (responseData) {
      result = responseData.map((item: AgencyResponseItem ) => {
        return new Agency(
          item.ID,
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : '',
          item.Path ? item.Path : ''
        )
      })
    }
    return result
  }
}
